import { get, post } from '../../utils/http';

export const fetchSupplierInvoices = ({ accountId, supplierId, from, to }) =>
  get(`/accounts/${accountId}/suppliers/${supplierId}/invoices`, {
    accountId,
    supplierId,
    from,
    to
  });

export const sendSupplierInvoiceEmail = ({ accountId, supplierId, from, to, supplierAdminIds, columns, sendCopy }) =>
  post(`/accounts/${accountId}/suppliers/${supplierId}/invoices/email`, {
    from,
    to,
    supplierAdminIds,
    columns,
    sendCopy
  });
